<template>
  <div>
    <view-news ref="dialog"></view-news>

    <v-toolbar dark color="primary">
      <v-toolbar-title class="white--text">
        <v-icon v-show="!progress">event_note</v-icon>
        {{ $t('entity.news') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <!--  <v-btn icon @click="grid = !grid">
        <v-icon v-show="!progress">{{ grid ? 'view_list' : 'view_module' }} </v-icon>
        <v-progress-circular indeterminate color="white" v-show="progress"></v-progress-circular>
      </v-btn>-->
    </v-toolbar>

    <div class="container-news elevation-0" color="grey lighten-5" flat>
      <v-toolbar dark color="primary" flat extended></v-toolbar>
      <v-row row>
        <v-col xs="10" offset-xs1>
          <div class="card--flex-toolbar">
            <v-container grid-list-md text-xs-center style="padding: 0px">
              <v-row row wrap>
                <v-col xs="12" md="8" class="content-carousel" v-if="carousel">
                  <v-card dark>
                    <v-carousel hide-delimiters v-if="carousel.length && !progress">
                      <v-carousel-item v-for="(item, i) in carousel" :src="item.image" :key="i">
                        <div class="bg-carousel">
                          <div class="text-content-carousel">
                            <div @click="selectNews(item)" style="cursor: pointer">
                              <h1 class="headline">{{ item.title }}</h1>
                              <span class="grey--text">{{ $moment().format('D MMMM YYYY') }}</span>
                              <br />
                              <p>{{ item.description }}...</p>
                            </div>
                          </div>
                        </div>
                      </v-carousel-item>
                      <div class="progress-carousel">
                        <v-progress-circular indeterminate color="white" v-show="progress"></v-progress-circular>
                      </div>
                    </v-carousel>
                  </v-card>
                </v-col>

                <v-col xs="12" md="4">
                  <v-card>
                    <v-app-bar flat color="white">
                      <v-toolbar-title class="body-1 grey--text">Ultimas noticias</v-toolbar-title>
                      <v-spacer></v-spacer>

                      <!-- <v-btn icon> -->
                      <v-icon>library_books</v-icon>
                      <!-- </v-btn> -->
                    </v-app-bar>

                    <v-list two-line>
                      <template v-for="(item, i) in news">
                        <div v-if="i < 5 && item.isPublic" :key="i">
                          <v-list-tile avatar ripple @click="selectNews(item)" :key="i">
                            <v-list-tile-content>
                              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                              <v-list-tile-sub-title>{{ item.description }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <!-- <v-list-tile-action-text>{{$moment(item.date).format('D M YYYY')}}</v-list-tile-action-text> -->
                              <v-list-tile-action-text>{{ item.date }}</v-list-tile-action-text>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-divider v-if="i + 1 < item.length" :key="i"></v-divider>
                        </div>
                      </template>
                    </v-list>
                  </v-card>
                </v-col>

                <template v-for="(item, i) in news">
                  <!--                  <v-col xs="12" sm="6" lg="6" v-if="grid && item.priority">
                    <div class="select-news" @click="selectNews(item)" >
                      <v-card xs5 color="darken-2" :style="{ 'background-color': item.newsPalette }" class="white--text grid-card">
                        <v-card-media class="card-media-height" :src="item.image" height="150px">
                        </v-card-media>
                        <v-card-title primary-title>
                          <div class="news-prev">
                            <div class="subheading">{{item.title}}</div>
                            <span class="date-text caption"><v-icon color="white" class="subheading">access_time</v-icon> {{item.date}}</span>
                          </div>
                        </v-card-title>
                      </v-card>
                    </div>
                  </v-col>
                  -->

                  <v-col xs="12" md="4" lg="4" v-if="grid && item.image && item.isPublic" :key="i">
                    <div class="select-news" @click="selectNews(item)">
                      <v-card xs5 color="darken-2" :style="{ 'background-color': item.newsPalette }" class="white--text grid-card" style="height: 300px !important">
                        <v-card-media class="card-media-height" :src="item.image" height="150px"></v-card-media>
                        <v-card-title primary-title style="height: 50%">
                          <div class="news-prev" v-if="item.image">
                            <div class="subheading" style="width: 100%">
                              {{ item.title }}
                            </div>
                            <span class="date-text caption">
                              <v-icon color="white" class="subheading">access_time</v-icon>
                              {{ item.date }}
                            </span>
                          </div>
                          <div class="news-prev no-image" v-if="!item.image">
                            <div class="subheading">{{ item.title }}</div>
                            <div style="text-align: center">
                              <span class="date-text caption">{{ item.date }}</span>
                            </div>
                          </div>
                        </v-card-title>
                      </v-card>
                    </div>
                  </v-col>

                  <v-col xs="12" md="4" lg="4" v-if="grid && !item.image && item.isPublic" :key="i">
                    <div class="select-news" @click="selectNews(item)">
                      <v-card xs5 color="darken-2" :style="{ 'background-color': item.newsPalette }" class="white--text grid-card" style="height: 300px !important; display: flex; flex-wrap: wrap; justify-content: center; align-items: center; padding: 15px">
                        <div class="subheading" style="width: 100%; line-height: 92%; font-size: 34px !important">
                          {{ item.title }}
                          <br />
                          <span class="date-text caption">
                            <v-icon color="white" class="subheading">access_time</v-icon>
                            {{ item.date }}
                          </span>
                        </div>
                      </v-card>
                    </div>
                  </v-col>

                  <!--  <v-col xs="12" v-if="!grid">
                    <div class="select-news" @click="selectNews(item)">
                      <v-card class="white--text list-card-image" :style="{ 'background-image': 'url(' + item.image + ')' }" color="darken-2">
                        <div class="list-card-text" :style="{'background': 'linear-gradient(to right, ' + item.newsPalette + ' 0%, ' + item.newsPalette + ' 30%, ' + item.newsPalette + ' 40%, transparent)'}">
                          <v-card-title primary-title>
                            <div class="news-prev">
                              <div class="subheading">{{item.title}}</div>
                              <span class="date-text caption"><v-icon color="white" class="subheading">access_time</v-icon> {{item.date}}</span>
                            </div>
                          </v-card-title>
                        </div>
                      </v-card>
                    </div>
                  </v-col>-->

                  <v-col xs="12" sm="6" v-if="!grid && !item.priority" :key="i">
                    <div class="select-news" @click="selectNews(item)">
                      <v-card
                        class="white--text list-card-image"
                        :style="{
                          'background-image': 'url(' + item.image + ')'
                        }"
                        color="darken-2"
                      >
                        <div
                          class="list-card-text"
                          :style="{
                            background: 'linear-gradient(to right, ' + item.newsPalette + ' 0%, ' + item.newsPalette + ' 30%, ' + item.newsPalette + ' 40%, transparent)'
                          }"
                        >
                          <v-card-title primary-title>
                            <div class="news-prev">
                              <div class="subheading">{{ item.title }}</div>
                              <span class="date-text caption">
                                <v-icon color="white" class="subheading">access_time</v-icon>
                                {{ item.date }}
                              </span>
                            </div>
                          </v-card-title>
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { db } from '@/firebase'
import { getToken } from '@/assets/js/shared/utils.js'
// var Vibrant = require('node-vibrant')
export default {
  data() {
    return {
      show: false,
      grid: true,
      temp: 'purple',
      progress: true,
      carousel: []
      // example
    }
  },
  firebase: {
    news: {
      source: db.ref(getToken().companyId + '_news'),
      // optionally bind as an object
      asObject: false,
      // optionally provide the cancelCallback
      cancelCallback: function () {},
      // this is called once the data has been retrieved from firebase
      readyCallback: function () {
        this.progress = false
        this.setColors()
        this.setCarouselItems()
      }
    }
  },
  methods: {
    selectNews(news) {
      this.$refs['dialog'].news = news
      this.$refs['dialog'].open()
      // companyTable.push(this.example)
    },
    setColors() {
      var colors = ['rgb(63, 81, 181)', 'rgb(156, 39, 176)', 'rgb(233, 30, 99)', 'rgb(255, 87, 34)', 'rgb(0, 150, 136)', 'rgb(76, 175, 80)', 'rgb(33, 150, 243)']
      this.news.forEach((e) => {
        e.newsPalette = colors[Math.floor(Math.random() * colors.length)]
        // console.log(e.image)
        // new Vibrant('https://ichef.bbci.co.uk/news/660/cpsprodpb/1594A/production/_96749388_gettyimages-504489358.jpg').getPalette().then((palette) => {
        //   e.newsPalette = palette
        //   console.log(e.newsPalette)
        // })
      })
    },
    setCarouselItems() {
      if (this.news.length <= 3) {
        this.news.forEach((e) => {
          e.image && e.isPublic ? this.carousel.push(e) : e
        })
      } else {
        var array = this.news.slice()
        for (var i = 0; i <= 3; i++) {
          var index = Math.floor(Math.random() * array.length)
          console.log(index)
          if (array[index].image && array[index].isPublic) {
            this.carousel.push(array[index])
            array.splice(index, 1)
          } else {
            array.splice(index, 1)
            //   i = i - 1
          }
        }
      }
      this.progress = false
    }
  },
  mounted() {
    setTimeout(() => {
      // this.progress = false
    }, 2000)
    // var a = Vibrant.from('https://images.pexels.com/photos/371633/pexels-photo-371633.jpeg?auto=compress&cs=tinysrgb&h=350')
  }
}
</script>

<style>
.no-image {
  width: 100% !important;
  margin-top: -70px;
}

.no-image .subheading {
  width: 100% !important;
  text-align: center !important;
  font-size: 24px !important;
}

.progress-carousel {
  width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.out-padding > .container {
  background: red;
}

.bg-carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.date-text {
  color: rgba(255, 255, 255, 0.7490196078431373);
}
.grid-card {
  height: 257px !important;
}

.text-content-carousel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65%;
  background: rgba(0, 0, 0, 0) linear-gradient(transparent, rgba(0, 0, 0, 0.85)) repeat scroll 0 0;
}

.text-content-carousel div {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 40px 40px 25px;
  text-align: left;
}

.text-content-carousel p {
  margin-top: 5px;
}

.card--flex-toolbar {
  margin-top: -74px;
}

.container-news .card--flex-toolbar {
  background: transparent;
  border: none;
  -webkit-box-shadow: inherit !important;
  box-shadow: inherit !important;
  padding: 0px !important;
  margin-bottom: 64px;
}

.container-news .divider {
  visibility: hidden;
}
.content-carousel .card {
  border-radius: 0 !important;
}
.select-news {
  cursor: pointer;
}
.news-prev {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  text-align: left;
  height: 100%;
}

.list-card-image {
  background-position: right;
  background-size: 60%;
  background-repeat: no-repeat;
}

.list-card-text {
  height: 100%;
  width: 100%;
  z-index: 100;
}
/*:style="{'background': 'url(https://www.edelman.com/assets/uploads/2016/05/Employee-Engagement-and-Communications-Marketing.jpg)'}"*/
</style>
